import { render, staticRenderFns } from "./addTeamTeach.vue?vue&type=template&id=02b89580&scoped=true"
import script from "./addTeamTeach.vue?vue&type=script&lang=js"
export * from "./addTeamTeach.vue?vue&type=script&lang=js"
import style0 from "./addTeamTeach.vue?vue&type=style&index=0&id=02b89580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b89580",
  null
  
)

export default component.exports